import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { configureSms, skipSetup } from '../../actions/security/SecurityPhoneNumberActions';
import { getSMSRegisterError } from '../../selectors/twoFactorAuth';
import { getStagedSMSNumber, getShouldBlockSetupProgress, getRedirectUrl } from '../../selectors/security/SecurityPhoneNumberSetupSelector';
import { SECURITY_PHONE_NUMBER } from '../../constants/TwoFactorAuthMethods';
import TwoFactorAuthSMSErrors from '../../constants/TwoFactorAuthSMSErrors';
import { changeSMSNumber } from '../../actions/TwoFactorAuthActions';
import RegisterSMS from '../../components/RegisterSMS';
import { jsx as _jsx } from "react/jsx-runtime";
class RegisterSMSStepContainer extends Component {
  constructor(...args) {
    super(...args);
    this.handleKeyUp = evt => {
      const {
        shouldBlockSetupProgress
      } = this.props;
      if (!shouldBlockSetupProgress && evt.keyCode === 13) {
        this.handleConfirmSetupStep();
      }
    };
  }
  handleConfirmSetupStep() {
    const {
      smsNumber
    } = this.props;
    this.props.configureSms(smsNumber);
  }
  render() {
    const {
      smsNumber,
      registerSmsError,
      redirectUrl
    } = this.props;
    return /*#__PURE__*/_jsx(RegisterSMS, {
      error: registerSmsError,
      number: smsNumber,
      onKeyUp: this.handleKeyUp,
      onNumberChange: this.props.changeSMSNumber,
      method: SECURITY_PHONE_NUMBER,
      redirectUrl: redirectUrl,
      onSkipPressed: this.props.skipSetup
    });
  }
}
RegisterSMSStepContainer.propTypes = {
  smsNumber: PropTypes.string.isRequired,
  registerSmsError: PropTypes.oneOf(Object.keys(TwoFactorAuthSMSErrors)),
  shouldBlockSetupProgress: PropTypes.bool.isRequired,
  changeSMSNumber: PropTypes.func.isRequired,
  configureSms: PropTypes.func.isRequired,
  redirectUrl: PropTypes.string,
  skipSetup: PropTypes.func.isRequired
};
function mapStateToProps(state) {
  return {
    smsNumber: getStagedSMSNumber(state),
    registerSmsError: getSMSRegisterError(state),
    shouldBlockSetupProgress: getShouldBlockSetupProgress(state),
    redirectUrl: getRedirectUrl(state)
  };
}
export default connect(mapStateToProps, {
  changeSMSNumber,
  configureSms,
  skipSetup
})(RegisterSMSStepContainer);